import Child from './Child';
import { FundRequestProvider } from './context/FormProvider';

const DialogFundRequest = () => (
	<FundRequestProvider>
		<Child />
	</FundRequestProvider>
);

export default DialogFundRequest;
